import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  contentWrapper: theme => css`
    margin: ${theme.spacing.sm} 0;

    > svg {
      display: flex;
      margin: 0 auto;
    }

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      margin: ${theme.spacing.xs} 0;
    }
  `,
})

export default useStyles
